import { createDiscountRule as publicCreateDiscountRule, getDiscountRule as publicGetDiscountRule, updateDiscountRule as publicUpdateDiscountRule, deleteDiscountRule as publicDeleteDiscountRule, queryDiscountRules as publicQueryDiscountRules, } from './ecom-discounts-v1-discount-rule-discount-rules.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import { onDiscountRuleCreated as publicOnDiscountRuleCreated } from './ecom-discounts-v1-discount-rule-discount-rules.public.js';
import { onDiscountRuleDeleted as publicOnDiscountRuleDeleted } from './ecom-discounts-v1-discount-rule-discount-rules.public.js';
import { onDiscountRuleUpdated as publicOnDiscountRuleUpdated } from './ecom-discounts-v1-discount-rule-discount-rules.public.js';
export const createDiscountRule = /*#__PURE__*/ createRESTModule(publicCreateDiscountRule);
export const getDiscountRule = /*#__PURE__*/ createRESTModule(publicGetDiscountRule);
export const updateDiscountRule = /*#__PURE__*/ createRESTModule(publicUpdateDiscountRule);
export const deleteDiscountRule = /*#__PURE__*/ createRESTModule(publicDeleteDiscountRule);
export const queryDiscountRules = /*#__PURE__*/ createRESTModule(publicQueryDiscountRules);
/**
 * Triggered when a discount rule is created.
 */
export const onDiscountRuleCreated = createEventModule(publicOnDiscountRuleCreated);
/**
 * Triggered when a discount rule is deleted.
 */
export const onDiscountRuleDeleted = createEventModule(publicOnDiscountRuleDeleted);
/**
 * Triggered when a discount rule is updated.
 */
export const onDiscountRuleUpdated = createEventModule(publicOnDiscountRuleUpdated);
export { ScopeType, TriggerType, Type, DiscountType, Status, AppliedSubjectType, SortOrder, WebhookIdentityType, } from './ecom-discounts-v1-discount-rule-discount-rules.universal.js';
//# sourceMappingURL=ecom-discounts-v1-discount-rule-discount-rules.context.js.map